// Размытие главного экрана
const firstScreenTriggerWrapper = document.querySelector('.j-first-screen-blur');

if (firstScreenTriggerWrapper) {
    const observeBlur = (): void => {
        if (window.pageYOffset > 250) {
            firstScreenTriggerWrapper.classList.add('is-active');
        } else {
            firstScreenTriggerWrapper.classList.remove('is-active');
        }
    };

    if ('IntersectionObserver' in window) {
        const blurObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    document.addEventListener('scroll', observeBlur);
                } else {
                    document.removeEventListener('scroll', observeBlur);
                }
            });
        });

        blurObserver.observe(firstScreenTriggerWrapper);
    }

    observeBlur();
}

// Простые анимации
const animationsBlocks = [...document.querySelectorAll('.j-animation-block')];

if (animationsBlocks.length) {
    if ('IntersectionObserver' in window) {
        const animationObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    if (!entry.target.classList.contains('is-active')) {
                        entry.target.classList.add('is-active');
                    }
                } else if (entry.target.classList.contains('is-active')) {
                    setTimeout(() => {
                        entry.target.classList.remove('is-active');
                    }, 500);
                }
            });
        });

        animationsBlocks.forEach((block: Element) => {
            animationObserver.observe(block);
        });
    } else {
        animationsBlocks.forEach((block: Element) => {
            block.classList.add('is-active');
        });
    }
}
